import { RiLightbulbLine } from '@remixicon/react';

import { MarkdownContent } from '../MarkdownContent';

import styles from './ThinkingMessage.module.css';

export const ThinkingMessage = ({ content }: { content: string }) => {
  return (
    <div className={styles.root}>
      <RiLightbulbLine size={16} className={styles.icon} />
      <div className={styles.content}>
        <MarkdownContent>{content}</MarkdownContent>
      </div>
    </div>
  );
};
